export class Version {
	public major: number;
	public minor: number | null;
	public patch: number | null;

	constructor(major: number, minor: number | null = null, patch: number | null = null) {
		this.major = major;
		this.minor = minor;
		this.patch = patch;
	}

	public toString = (): string => {
		const { major, minor, patch } = this;

		let version = `Version ${major}`;
		if (minor !== null) version += `.${minor}`;
		if (patch !== null) version += `.${patch}`;

		return version;
	};

	private compare(other: Version): number {
		if (this.major > other.major) return 1;
		if (this.major < other.major) return -1;
		if ((this.minor ?? 0) > (other.minor ?? 0)) return 1;
		if ((this.minor ?? 0) < (other.minor ?? 0)) return -1;
		if ((this.patch ?? 0) > (other.patch ?? 0)) return 1;
		if ((this.patch ?? 0) < (other.patch ?? 0)) return -1;
		return 0;
	}

	public equals(version: Version): boolean {
		return this.compare(version) === 0;
	}

	public gt(other: Version): boolean {
		return this.compare(other) > 0;
	}

	public gte(other: Version): boolean {
		return this.equals(other) || this.gt(other);
	}

	public lt(other: Version): boolean {
		return this.compare(other) < 0;
	}

	public lte(other: Version): boolean {
		return this.equals(other) || this.lt(other);
	}
}
